import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-pos-person-reference-modal',
  templateUrl: './pos-person-reference-modal.component.html',
  styleUrls: ['./pos-person-reference-modal.component.sass']
})
export class PosPersonReferenceModalComponent implements OnInit {

  @Input() isShortFormActiveForPlan = false;
  constructor(private bsModalRef: BsModalRef, private onbaseService: OnbaseService) {
  }
  confirmAction: (form: FormGroup) => any = () => { };
  form: FormGroup = new FormGroup({
    firstName: new FormControl("", Validators.required),
    middleName: new FormControl(""),
    lastName: new FormControl("", Validators.required),
    secondLastName: new FormControl(""),
    familyRelationship: new FormControl("", Validators.required),
    mobilePhone: new FormControl("", Validators.required),
    phone: new FormControl(""),
    workPhone: new FormControl(""),
    workPhoneExtension: new FormControl(""),
  });
  familyRelationships: Array<{ key: string, value: string }> = [];
  async ngOnInit(): Promise<void> {
    let onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    this.familyRelationships = ObjectUtils.objectToArray(onbaseCatalogue.naturalRelation);
  }

  confirm() {
    this.confirmAction(this.form);
    this.bsModalRef.hide();
  }

  draft() {
    this.confirmAction(this.form);
    this.bsModalRef.hide();
  }
  close() {
    this.bsModalRef.hide();
  }
}
